import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useUpdateEmpresaActivaLogo } from "api/Empresa.hook"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import Dropzone from "common/components/Dropzone"
import { useState } from "react"
import { useTranslation } from "react-i18next"

const Logo = () => {
  const { t } = useTranslation()
  const [infoImage, setInfoImage] = useState({})
  const {
    activeCompany: { logoAsBase64, id },
  } = useUsuarioEmpresaActiva()
  const { updateLogoMutation, deleteLogoMutation } =
    useUpdateEmpresaActivaLogo()

  const handleUploadFacturas = async (files: $TSMigrationFixMe) => {
    setInfoImage(files[0])
    updateLogoMutation({ logo: files[0], id })
  }

  const handleDeleteLogo = () => {
    deleteLogoMutation()
  }

  return (
    <div className='tw-w-full'>
      <div className='tw-justify-start tw-w-full tw-flex'>
        <p className='tw-mb-2'>{t("perfilEmpresa.company.logo.title")}</p>
      </div>
      <div className='tw-flex tw-justify-center'>
        {!logoAsBase64 ? (
          <Dropzone
            lite
            maxSize='4097152'
            accept='image/*'
            acceptLabel='image/*'
            onDrop={handleUploadFacturas}
          />
        ) : (
          <div className='tw-w-full tw-flex tw-justify-start tw-items-center'>
            <div className='tw-w-40 tw-h-20 tw-flex tw-justify-center'>
              <img
                src={logoAsBase64}
                alt='logo'
                className='tw-h-full'
              />
            </div>
            {/* @ts-expect-error TS(2339): Property 'name' does not exist on type '{}'. */}
            {infoImage?.name && (
              <div className='tw-items-center tw-justify-start ml-5 tw-flex mr-5'>
                <div>
                  {/* @ts-expect-error TS(2339): Property 'name' does not exist on type '{}'. */}
                  <b>{infoImage?.name}</b> <br />
                  {/* @ts-expect-error TS(2339): Property 'size' does not exist on type '{}'. */}
                  {infoImage?.size && (
                    <>
                      {/* @ts-expect-error TS(2339): Property 'size' does not exist on type '{}'. */}
                      {infoImage?.size > 1000000 ? (
                        // @ts-expect-error TS(2339): Property 'size' does not exist on type '{}'.
                        <span>{(infoImage?.size / 1000000).toFixed(2)} MB</span>
                      ) : (
                        // @ts-expect-error TS(2339): Property 'size' does not exist on type '{}'.
                        <span>{(infoImage?.size / 1000).toFixed(2)} KB</span>
                      )}
                    </>
                  )}
                </div>
              </div>
            )}
            <div className='tw-items-center tw-justify-start tw-flex'>
              <div
                className='tw-w-8 tw-h-8 tw-bg-neutral-25 tw-justify-center tw-items-center tw-flex tw-rounded-full tw-cursor-pointer tw-text-simple-10'
                onClick={handleDeleteLogo}
                title={`${t("perfilEmpresa.company.logo.delete")}`}
              >
                <FontAwesomeIcon icon={["fal", "x"]} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Logo
